import { setupI18n } from '@lingui/core'

const i18n = setupI18n();

export default i18n;
